Object.defineProperty(exports,"__esModule",{value:true});var _isEqual2=require("lodash/isEqual");var _isEqual3=_interopRequireDefault(_isEqual2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _helpers=require("../victory-util/helpers");var _helpers2=_interopRequireDefault(_helpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var


Bar=function(_React$Component){_inherits(Bar,_React$Component);function Bar(){_classCallCheck(this,Bar);return _possibleConstructorReturn(this,(Bar.__proto__||Object.getPrototypeOf(Bar)).apply(this,arguments));}_createClass(Bar,[{key:"componentWillMount",value:function componentWillMount()























{var _calculateAttributes=
this.calculateAttributes(this.props),style=_calculateAttributes.style,path=_calculateAttributes.path;
this.style=style;
this.path=path;
}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(

nextProps){var _calculateAttributes2=
this.calculateAttributes(nextProps),style=_calculateAttributes2.style,path=_calculateAttributes2.path;
if(path!==this.path||!(0,_isEqual3.default)(style,this.style)){
this.style=style;
this.path=path;
return true;
}
return false;
}},{key:"calculateAttributes",value:function calculateAttributes(

props){var
datum=props.datum,active=props.active,x=props.x,y=props.y;
var stroke=props.style&&props.style.fill||"black";
var baseStyle={fill:"black",stroke:stroke};
var style=_helpers2.default.evaluateStyle((0,_assign3.default)(baseStyle,props.style),datum,active);
var width=this.getBarWidth(props,style);
var path=typeof x==="number"&&typeof y==="number"?
this.getBarPath(props,width):undefined;
return{style:style,path:path};
}},{key:"getVerticalBarPath",value:function getVerticalBarPath(

props,width){
var size=width/2;
var y0=Math.round(props.y0);
var y1=Math.round(props.y);
var x0=Math.round(props.x-size);
var x1=Math.round(props.x+size);
return"M "+x0+", "+y0+"\n      L "+
x0+", "+y1+"\n      L "+
x1+", "+y1+"\n      L "+
x1+", "+y0+"\n      L "+
x0+", "+y0+"\n      z";

}},{key:"getHorizontalBarPath",value:function getHorizontalBarPath(

props,width){
var size=width/2;
var y0=Math.round(props.y0);
var y1=Math.round(props.y);
var x0=Math.round(props.x-size);
var x1=Math.round(props.x+size);
return"M "+y0+", "+x0+"\n      L "+
y0+", "+x1+"\n      L "+
y1+", "+x1+"\n      L "+
y1+", "+x0+"\n      L "+
y0+", "+x0+"\n      z";

}},{key:"getBarPath",value:function getBarPath(

props,width){
return this.props.horizontal?
this.getHorizontalBarPath(props,width):this.getVerticalBarPath(props,width);
}},{key:"getBarWidth",value:function getBarWidth(

props,style){
if(style.width){
return style.width;
}var

width=props.width,data=props.data;
var padding=props.padding.left||props.padding;
var defaultWidth=data.length===0?8:(width-2*padding)/data.length;
return defaultWidth;
}},{key:"renderBar",value:function renderBar(


path,style,events){var _props=
this.props,role=_props.role,shapeRendering=_props.shapeRendering,className=_props.className;
return(
_react2.default.createElement("path",_extends({
d:path,
className:className,
style:style,
role:role||"presentation",
shapeRendering:shapeRendering||"auto"},
events)));


}},{key:"render",value:function render()

{
return this.renderBar(this.path,this.style,this.props.events);
}}]);return Bar;}(_react2.default.Component);Bar.propTypes={active:_react.PropTypes.bool,className:_react.PropTypes.string,datum:_react.PropTypes.object,events:_react.PropTypes.object,horizontal:_react.PropTypes.bool,index:_react.PropTypes.number,role:_react.PropTypes.string,scale:_react.PropTypes.object,shapeRendering:_react.PropTypes.string,style:_react.PropTypes.object,x:_react.PropTypes.number,y:_react.PropTypes.number,y0:_react.PropTypes.number,width:_react.PropTypes.number,padding:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.object]),data:_react.PropTypes.array};exports.default=Bar;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/bar.js
// module id = 1469
// module chunks = 0